<a-quick-filter-button (click)="toggleQuickFilter(deviceTypes.MOBILE)"
                       [active]="this.typesSelected.indexOf(deviceTypes.MOBILE)>-1">
    {{'DeviceType.MOBILE' | translate}}
</a-quick-filter-button>

<a-quick-filter-button (click)="toggleQuickFilter(deviceTypes.TABLET)"
                       [active]="this.typesSelected.indexOf(deviceTypes.TABLET)>-1">
    {{'DeviceType.TABLET' | translate}}
</a-quick-filter-button>
